import React from 'react';
import { Button, CloseButton, Form, Modal, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import useOrdenOperations from '../hooks/useOrdenOperations';
import useOrdenComentarios from '../hooks/useOrdenComentarios';
import useOrdenNotificaciones from '../hooks/useOrdenNotificaciones';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const OrdenModalCancelar = ({
    showCancelarOrdenModal,
    setShowCancelarOrdenModal,
    motivoCancelacionOrden,
    setMotivoCancelacionOrden,
    orden,
    onOrdenCancelada
}) => {
    const { cancelarOrden, loadingEdit } = useOrdenOperations();
    const { guardarComentario } = useOrdenComentarios();
    const { crearObjAction, guardarNotificacion } = useOrdenNotificaciones();
    const { nombreCompleto } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const handleCancelarOrden = async () => {
        if (!motivoCancelacionOrden || !motivoCancelacionOrden.trim()) {
            showErrorToast('Debe ingresar un motivo para cancelar la orden.');
            return;
        }

        const ahora = new Date();
        const fechaHora = ahora.toLocaleString('es-MX', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });

        await cancelarOrden(
            orden.idOrden,
            motivoCancelacionOrden,
            (mensaje) => {
                // Enviar notificación
                const objToActionString = crearObjAction(2, "/ordenes/detalle/" + orden.idOrden, '', '');
                const jsonData = JSON.stringify({ idOrden: orden.idOrden });

                guardarNotificacion(
                    "Orden cancelada",
                    `<strong>${nombreCompleto}</strong> canceló la orden <strong>#${orden.idOrden}</strong> el ${fechaHora}`,
                    0,
                    objToActionString,
                    8,
                    jsonData,
                    () => { },
                    (error) => {
                        showErrorToast(error);
                    }
                );

                setShowCancelarOrdenModal(false);
                setMotivoCancelacionOrden("");
                showSuccessToast(mensaje);

                // Callback para recargar datos
                onOrdenCancelada?.();
            },
            (error) => {
                // Error
                showErrorToast(error);
                
            }
        );
    };

    return (
        <Modal
            show={showCancelarOrdenModal}
            onHide={() => { setShowCancelarOrdenModal(false); setMotivoCancelacionOrden(''); }}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton className="border-bottom-0 pb-0">
                <Modal.Title id="contained-modal-title-vcenter" className="text-danger fs-2">
                    Confirmar Cancelación de Orden
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="alert alert-warning mb-3">
                    <strong>¿Estás seguro de que deseas cancelar la orden #{orden.idOrden}?</strong>
                    <div className="mt-1 small">Esta acción cancelará la orden de forma permanente sin ningún tipo de candado o restricción.</div>
                </div>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label className="fs--1 fw-semi-bold">
                        Motivo de la cancelación <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Escribe el motivo de la cancelación aquí..."
                        onChange={(event) => { setMotivoCancelacionOrden(event.target.value); }}
                        value={motivoCancelacionOrden}
                        onKeyDown={
                            (e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    handleCancelarOrden();
                                }
                            }
                        }
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer className="border-top-0 pt-0">
                <Button variant='light' onClick={() => { setShowCancelarOrdenModal(false); setMotivoCancelacionOrden(''); }} disabled={loadingEdit}>
                    Cerrar
                </Button>

                {
                    !loadingEdit ?
                        <Button variant='danger' onClick={handleCancelarOrden} className="d-flex align-items-center gap-2">
                            Confirmar Cancelación
                        </Button>
                        :
                        <>
                            <Button variant="danger" disabled className="d-flex align-items-center gap-2">
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Procesando...
                            </Button>
                        </>
                }
            </Modal.Footer>
        </Modal>
    );
};

OrdenModalCancelar.propTypes = {
    showCancelarOrdenModal: PropTypes.bool.isRequired,
    setShowCancelarOrdenModal: PropTypes.func.isRequired,
    motivoCancelacionOrden: PropTypes.string.isRequired,
    setMotivoCancelacionOrden: PropTypes.func.isRequired,
    orden: PropTypes.object.isRequired,
    onOrdenCancelada: PropTypes.func
};

export default OrdenModalCancelar;